import React from "react";
import fb from "../images/facebook.svg";
import green from "../images/green.svg";
import pink from "../images/pink.svg";
import white from "../images/white.svg";
import yellow from "../images/yellow.svg";
import orange from "../images/orange.svg";
import tw from "../images/twitter.svg";
import ins from "../images/insta.svg";
import img from "../images/fotimg.png";

const Footer = ({ color }) => {
  return (
    <div className="pt-[200px] relative overflow-x-hidden">
      <div className="border-b-[1px]">
        <div className="flex md:flex-row flex-col base-wrapper">
          <div className="md:w-[70%] flex flex-col gap-[30px] items-center">
            <div className="text-[#FF9142] text-[22px] text-center mt-[150px]">
              Get in Touch With Us
            </div>
            <p className="text-[24px] md:text-[58px] font-[700]">
              Introverse11@gmail.com
            </p>
            <div className="flex gap-[30px] my-[50px] md:my-[100px]">
              <img src={fb} alt="" className="w-[40px] md:w-[82px]" />
              <img src={tw} alt="" className="w-[40px] md:w-[82px]" />
              <img src={ins} alt="" className="w-[40px] md:w-[82px]" />
            </div>
          </div>
          {/* <BgColor color="green" /> */}

          <img
            src={
              color === "green"
                ? green
                : color === "white"
                ? white
                : color === "pink"
                ? pink
                : color === "orange"
                ? orange
                : yellow
            }
            alt=""
            className="scale-[2] h-[500px]"
          />
        </div>
      </div>
      <div className="md:w-[70%] text-center mr-auto py-[30px] text-[22px] font-[700]">
        © 2023. Introverse. All rights reserved.{" "}
      </div>
      <img
        src={img}
        alt=""
        className="absolute md:right-[0px] md:bottom-0 right-[80px] bottom-[95px] h-[500px] md:h-[763px]"
      />
    </div>
  );
};

export default Footer;
